/** Browse column card. Height comes from .page-panel. */
export const PAGE_PANEL_CLASS =
    'flex flex-col w-full bg-white rounded-lg border min-h-[500px] page-panel relative shadow-sm';

/** Profile block on the page. The dark: fill opts this white card out of the generic night remap. */
export const PROFILE_MODULE_CLASS = 'profile-module bg-white rounded-lg dark:bg-jw-surface-2';

/** Cork behind Jam Board pins and the highlights wall. */
export const CORK_CLASS = 'min-h-full bg-[#e8dcc8] bg-[length:24px_24px] shadow-inner dark:bg-jw-surface';

/** Cream pin card. Call sites add rotation, padding, and hover. */
export const PIN_PAPER_CLASS =
    'jw-box relative rounded-lg border border-amber-900/20 bg-[#fffdf8] shadow-[0_8px_24px_-14px_rgba(0,0,0,0.55)] dark:bg-jw-surface-2 dark:border-jw-line';

/** Header search pill. Width stays at the call site. */
export const HEADER_SEARCH_SHELL_CLASS =
    'relative flex items-center bg-lightblue-100 rounded-full h-10 dark:bg-jw-surface-2';

/** Boost and Refer. Night text stays dark on the light purple fill. */
export const HEADER_LIGHT_ACTION_CLASS =
    'bg-lightpurple flex items-center px-3 hover:scale-105 transition-transform font-nunito h-10 dark:text-[#1f2937]';

/** Night-mode switch track. The knob stays white at the call site. */
export const nightTrackClass = (on: boolean): string =>
    (on ? 'bg-jw-accent dark:bg-jw-wine' : 'bg-neutral-300 dark:bg-jw-line-strong');
